import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { Box, Flex, Text, Select, Group, Pagination } from '@mantine/core'
import { getAllOrderList } from '../../../../services/orders'
import { useDebouncedCallback } from '@mantine/hooks'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableCommisionUser from '../../../../component/pages/Users/TableCommisionUser'
import classes from '../../../../assets/module-css/AdminLayout.module.css'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 20,
  'is_commissioned': 'all',
  'fields[-order]': 'details',
  'fields[order]': 'commision_page_data,currency'
}

const defaultFilterCommision = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Agent',
    value: 'agent'
  },
  {
    label: 'Partner',
    value: 'partner'
  }
]

const labelTable = [
  {
    label: 'Date',
    width: 'auto'
  },
  {
    label: 'Commision For',
    width: 'auto'
  },
  {
    label: 'Agent / Partner',
    width: 'auto'
  },
  {
    label: 'Order Code',
    width: 'auto'
  },
  {
    label: 'Handling Fee',
    width: 'auto'
  },
  {
    label: 'Commision Amount',
    width: 'auto'
  },
  {
    label: 'Payout ID',
    width: 'auto'
  },
]

const CommisionList = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState(defaultParameter)
  const [commisionList, setCommisionList] = useState([])
  const [totalUser, setTotalUser] = useState(0)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'users',
      route: null
    },
    {
      label: 'commisions',
      route: null
    },
  ]

  const handleGetListCommisions = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllOrderList(params)
      if (response.success) {
        const { data, meta } = response

        const countData = meta.pagination.total || 0

        const remapData = data.map((val) => {
          return {
            ...val.attributes.commision_page_data,
            currency: val.attributes.currency
          }
        })

        setCommisionList(remapData)
        setTotalUser(countData)
      } else {
        setCommisionList([])
        setTotalUser(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 300)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetListCommisions()
    // eslint-disable-next-line
  }, [params])

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val }))
    handleChangePage(1)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="end" mb={30}>
            <Text className={classes.titleLayout}>Commision User</Text>
            <Select
              label="Filter By Role"
              data={defaultFilterCommision}
              value={params['is_commissioned']}
              onChange={(val) => handleFilter('is_commissioned', val)}
              size='xs'
              allowDeselect={false}
            />
          </Flex>
          <Group my={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{loading ? 0 : totalUser} Users </Text>
          </Group>

          <Box my={30}>
            {loading ? <LoadingData /> : commisionList.length > 0 ? <TableCommisionUser label={labelTable} data={commisionList} /> : <NoData />}
          </Box>

        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalUser / params['page[limit]']) || 0} />
        </Flex>
        </Box>
      </Box>
    </AuthLayout>
  )
}

export default CommisionList